import { CgsEvent } from '@cgs/wge';

export class ResumeEvent extends CgsEvent {}
